/**
 * atomberg-local-cache.js
 *
 * TTL cache over localStorage. Each store is one JSON map under its own key;
 * expired entries are pruned on every write so a store never grows unbounded.
 * Fails soft — private mode or a full quota reads as a miss and drops writes.
 *
 * API (window.AtombergLocalCache):
 *   read(store, id, ttlMs)          → cached value, or null when absent/expired
 *   write(store, id, value, ttlMs)
 */
(function () {
  'use strict';

  /** @type {any} */
  var w = window;
  if (w.AtombergLocalCache) return;

  /**
   * @param {string} store
   * @returns {Record<string, {v: any, ts: number}>}
   */
  function load(store) {
    try {
      var map = JSON.parse(localStorage.getItem(store) || '{}');
      return map && typeof map === 'object' ? map : {};
    } catch (_) {
      return {};
    }
  }

  /**
   * @param {string} store
   * @param {string} id
   * @param {number} ttlMs
   * @returns {any}
   */
  function read(store, id, ttlMs) {
    var hit = load(store)[id];
    if (hit && 'v' in hit && Date.now() - hit.ts < ttlMs) return hit.v;
    return null;
  }

  /**
   * @param {string} store
   * @param {string} id
   * @param {any} value
   * @param {number} ttlMs
   */
  function write(store, id, value, ttlMs) {
    var map = load(store);
    var now = Date.now();
    map[id] = { v: value, ts: now };
    Object.keys(map).forEach(function (k) {
      if (!(now - map[k].ts < ttlMs)) delete map[k];
    });
    try {
      localStorage.setItem(store, JSON.stringify(map));
    } catch (_) {}
  }

  w.AtombergLocalCache = { read: read, write: write };
})();
